import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountSubType } from "@front/m19-api-client";
import { AccountSelectionService, isReadOnlyAccess } from "@front/m19-services";
import { IButtonDirective, IIconComponent } from "@front/m19-ui";
import { AccountSettingsV2Service } from "@m19-board/services/account-settings.service";

@Component({
  selector: "app-grant-selling-partner-access-button",
  imports: [IButtonDirective, IIconComponent],
  template: `
    @if (canGrant()) {
      <button iButton size="md" variant="secondary" (click)="requestGrant()"><IIcon name="plug" />{{ label() }}</button>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GrantSellingPartnerAccessButtonComponent {
  private readonly accountSettingsService = inject(AccountSettingsV2Service);
  private readonly accountSelectionService = inject(AccountSelectionService);

  label = input.required<string>();

  private readonly accountMarketplace = toSignal(this.accountSelectionService.singleAccountMarketplaceSelection$, {
    requireSync: true,
  });

  protected readonly canGrant = computed(() => !isReadOnlyAccess(this.accountMarketplace().accessLevel));

  protected requestGrant(): void {
    const accountMarketplace = this.accountMarketplace();
    this.accountSettingsService.grantSellingPartnerAccess(
      accountMarketplace.accountId,
      accountMarketplace.marketplace,
      accountMarketplace.accountType!,
      accountMarketplace.accountSubType === AccountSubType.KDP_AUTHOR,
    );
  }
}
